<template>
  <div class="main-container__back">
    <v-icon @click="goBack" class="icon">mdi mdi-arrow-left</v-icon>
  </div>
  <div class="main-container">
    <div class="main-container__news">
      <div class="main-container__desc">
        <h1>
          {{ this.newsData.title }}
        </h1>
        <div class="main-container__image">
          <img :src="getAbsoluteImageUrl(this.newsData.image)" />
        </div>
        <div class="main-container__text">
          <p>{{ removeHtmlTags(this.newsData.body) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNews} from "@/utils/endpoint";
export default {
  data() {
    return {
      newsData: {},
      default: 0,
    };
  },
  mounted() {
    this.default = 0;
    this.getNewsData(this.$route.params.id);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    removeHtmlTags(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const textContent = (doc.body.textContent || "").trim();

      return textContent;
    },
    extractTextFromHtml(htmlString) {
      // Use DOMParser to parse the HTML string
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      // Find the anchor tag in a safer way
      const anchorTag = doc.querySelector("a");

      // Return the text content of the anchor tag or an empty string if not found
      return anchorTag ? anchorTag.textContent : "";
    },
    getAbsoluteImageUrl(html) {
      const relativeSrc = this.extractSrcFromHtml(html);
      if (relativeSrc) {
        const baseUrl = "https://cms.lloret.cat/";
        return `${baseUrl}${relativeSrc}`;
      }
      return null;
    },
    extractSrcFromHtml(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const imgElement = doc.querySelector("img");
      return imgElement ? imgElement.getAttribute("src") : null;
    },
    // async getNewsDataDetail(id) {
    //   await getNewsDetail(id).then((res) => {
    //     if (res.data.rows.length != 0) {
    //       this.newsData = res.data.rows[0];
    //     } else {
    //       this.default = 1;
    //       this.newsData = {};
    //       this.newsData = {
    //         title: "No hay noticias",
    //         image: require("@/assets/Logo-LLM.jpg"),
    //         body: "No hay noticias",
    //       };
    //       console.log(this.newsData);
    //     }
    //   });
    // },
     async getNewsData(id) {
      await getNews(this.$route.params.page).then((res) => {
        let aux = res.data.rows;
        for(let i=0; i<aux.length; i++){
          if(i == id){
            this.newsData = aux[i];
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.main-container {
  margin: 0 auto;
  width: 70%;
}

.main-container__image {
  width: 825px;
  height: 475px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 20px;
}

.main-container__image img {
  width: 825px;
  height: 100%;
}
.main-container__desc h1 {
  text-align: center;
  text-decoration: none;
}

.main-container__desc h1:visited {
  color: black;
}

.main-container__text {
  width: 825px;
  margin: 0 auto;
  padding-bottom: 20px;
  text-align: justify;
}

.main-container__news {
  padding-top: 50px;
  margin-bottom: 10px;
}

.main-container__back {
  width: 100%;
}

.main-container__back .icon {
  color: black;
  margin: 10px;
}

.main-container__back .icon:hover {
  color: gray;
}

@media (max-width: 1024px) {
  .main-container__image {
    width: 550px;
    height: 350px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 20px;
  }

  .main-container__image img {
    width: 550px;
    height: 100%;
  }

  .main-container__text {
    width: 550px;
    max-height: 500px;
    overflow: auto;
  }
  .main-container {
    width: 90%;
  }
}

@media (max-width: 700px) {
  .main-container__image {
    width: 400px;
    height: 260px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 20px;
  }

  .main-container__image img {
    width: 400px;
    height: 100%;
  }

  .main-container__text {
    width: 400px;
    max-height: 500px;
    overflow: auto;
  }
  .main-container {
    width: 90%;
  }
}

@media (max-width: 480px) {
  .main-container__image {
    width: 300px;
    height: 240px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 20px;
  }

  .main-container__image img {
    width: 300px;
    height: 100%;
  }

  .main-container__text {
    width: 300px;
    max-height: 500px;
    overflow: auto;
  }
  .main-container {
    width: 90%;
  }
}
</style>
